import { Component, OnInit, Input } from '@angular/core';
import { ToasterService } from 'angular5-toaster';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from './../../services/admin/general.service';
import { StorageService } from '../../services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { IndicadorImpuestosService } from '../../services/indicador-impuestos/indicador-impuestos.service';
import { IndicadoresImpuestosExtModalComponent } from './add-modal/add-modal.component';

@Component({
  selector: 'app-indicadores-impuestos',
  templateUrl: './indicadores-impuestos.component.html',
  styleUrls: ['./indicadores-impuestos.component.scss'],
  providers: [GeneralService, IndicadorImpuestosService]
})
export class IndicadoresDeImpuestosComponent implements OnInit {
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  rows = [];
  rowsTmp = [];
  loading: boolean = true;
  indicadorFiltro: any = '';
  indicadores: any[] = [];
  modalRespuesta;

  toastRegistroDe;
  constructor(
    private translate: TranslateService,
    private modalService: NgbModal,
    private general: GeneralService,
    private indicadoresImpuestosService: IndicadorImpuestosService,
    private toasterService: ToasterService,
    private storageService: StorageService

  ) {
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.toastRegistroDe').subscribe(
      text => {
        this.toastRegistroDe = text;
      });
  }

  ngOnInit() {
    this.noBack();
    this.modulo();
    this.obtenerIndicadores();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('INDICADORES DE IMPUESTOS EXTRANJEROS').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  obtenerIndicadores() {
    this.rows = [];

    this.loading = true;
    this.indicadoresImpuestosService.getIndicadoresDeImpuestos().subscribe(
      data => {
        this.rows = [...data.indicadorImpExt];
        this.rowsTmp = [...data.indicadorImpExt];
        this.loading = false;
      },
      err => {
        this.loading = false;
        this.toasterService.pop('error', 'Error', err.message);
      },
    );
  }

  obtenerIndicador() {
    if (this.indicadorFiltro.trim() !== '') {
      this.indicadores = [];

      this.loading = true;
      this.indicadoresImpuestosService.getInidicadorDeImpuesto(this.indicadorFiltro).subscribe(
        data => { 
          this.indicadores = [...data.indicadorImpExt]; 
          this.rows = [...this.indicadores];
          this.loading = false;
        },
        err => {
          this.loading = false;
        },
      );
    } else {
      this.rows = [...this.rowsTmp];
    }
  }

  openModalRegistro(row) {
    const modalRef = this.modalService.open(IndicadoresImpuestosExtModalComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.row = row;
    modalRef.result.then(
      (result) => {
          if (result === 'success') {
            this.obtenerIndicadores();
          } 
      }
    )
    .catch((error) => {
        // console.log(error);
    });

  }

  borrarRegimenFiscal(row) {
      this.loading = true;
      this.indicadoresImpuestosService.deleteIndicadorDeImpuesto(row.indicador).subscribe(
        data => { 
          let response = data.result;

          if (response.estatus === 'S') {
            this.toasterService.pop('success', '', response.mensaje);
            this.obtenerIndicadores();
          } else {
            this.toasterService.pop('error', 'Error', response.mensaje);
          }

          this.loading = false;
        },
        err => {
          this.loading = false;
        },
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/indicadores-impuestos/indicadores-impuestos.component.ts